<template>
    <v-row justify="center" style="display:none">
        <v-overlay :z-index="zIndex" :value="overlay" opacity=".9">
            <v-layout wrap px-5>
                <v-flex xs8 text-left offset-xs2>
                    <h3>Seja bem-vindo!</h3>
                    <p>Assista o vídeo e veja como é rápido e distribuir os seus produtos!</p>
                </v-flex>
                <v-flex xs1>
                    <v-btn
                        px-3
                        py-3
                        class="white--text"
                        color="red"
                        fab
                        small
                        @click="overlay = false"
                    >
                        <v-icon>clear</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs8 offset-xs2 text-center>
                    <iframe
                        :width="videoSize().w"
                        :height="videoSize().h"
                        src="https://www.youtube.com/embed/1qMsx1Whvbg"
                        frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                </v-flex>
            </v-layout>
        </v-overlay>
    </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data: () => ({
        overlay: false,
        zIndex: 10
    }),
    computed: {
        ...mapGetters(["wizard"])
    },
    methods: {
        start(name) {
            this.overlay = false;
            this.wizard.name = name;
            this.wizard.components_zindexed = ["btn_insights"];
        },
        videoSize: function() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return { w: "300px", h: "168px" };
                case "sm":
                    return { w: "460px", h: "258px" };
                case "md":
                    return { w: "560px", h: "315px" };
                case "lg":
                    return { w: "800px", h: "450px" };
                case "xl":
                    return { w: "1200px", h: "675px" };
            }
        }
    }
};
</script>